<template>
  <StockCompare>
    <div class="stockview-dashboard">
      <div class="columns is-desktop">
        <div class="column">Sellers</div>
      </div>
    </div>
  </StockCompare>
</template>

<script>
export default {
  name: 'StockCompareSellers',
  components: {
    StockCompare: () => import('./StockCompare')
  }
}
</script>

<style lang="sass">
.card-header
  background: $white
</style>
